import { isBlank, financialToNumber } from 'utils';
import _ from 'lodash';
import { QuotationsType } from 'containers/OutWorkbench/utils';

export const getTranslatedFormItem = (formItem: any, intl: any, messages: any) => {
  const item = { ...formItem };
  const itemKeys = ['label'];
  itemKeys.forEach((key: string) => {
    const value = item[key];

    if (value && messages[value]) {
      item[key] = intl.formatMessage(messages[value])
    } else {
      item[key] = value;
    }
  });

  const childProps = item.childProps ? { ...item.childProps } : null;
  const childKeys = ['placeholder', 'items', 'uploadTips'];
  if (childProps) {
    childKeys.forEach((key: string) => {
      const value = childProps[key];
      if (value) {
        if (Array.isArray(value)) {
          childProps[key] = value.map((val: any) => {
            return { ...val, label: intl.formatMessage(messages[val.label]) };
          });
        } else if (typeof value === 'string') {
          if (key === 'uploadTips') {
            childProps[key] = intl.formatMessage(messages[value], { value: '200M' });
          } else {
            childProps[key] = intl.formatMessage(messages[value]);
          }
        }
      }
    });
  }

  return { ...item, childProps };
};

export const getCooperateAccountsQuoteData = (detail: any = {}, intl: any, messages: any) => {
  const { current_supplier_id, project_plan_info = {}, project_suppliers = [], depth } = detail;
  const { cooperate_accounts = [] } = project_plan_info;
  let quoteTotalPrice = 0;
  let preQuoteTotalPrice = 0;
  let preQuoteTotalPriceCurrency = 'rmb';
  const data = cooperate_accounts.map((account: any, index: number) => {
    const { superior_resource_ships = [] } = account;
    let quotePrice = 0;
    let isWin = false;
    let quoteId;
    let currency = 'rmb';
    let currencyName = 'RMB';
    let programDesc = '';
    let preQuotePrice = 0;
    let preQuotePriceCurrency = 'rmb';
    project_suppliers.forEach((supp: any) => {
      const { project_supplier_quotes = [], last_round_quotes } = supp;
      project_supplier_quotes.forEach((quote: any) => {
        if (supp.supplier_id === current_supplier_id && quote.cooperate_account_id === account.id) {
          quotePrice = _.add(quotePrice, quote.quote_price ? financialToNumber(`${quote.quote_price}`) || 0 : 0);
          isWin = !isWin ? quote.winning : isWin;
          quoteId = quote.id;
          currency = quote.currency;
          currencyName = quote.translated_currency;
          programDesc = quote.program_desc;
        }
      });
      // 上一轮报价
      const last_quote = last_round_quotes?.find((quote: any) => {
        return quote.cooperate_account_id === account.id;
      });
      if (last_quote) {
        preQuotePrice = _.add(preQuotePrice, last_quote.quote_price ? financialToNumber(`${last_quote.quote_price}`) || 0 : 0);
        preQuotePriceCurrency = last_quote.currency;
      }
    });
    if (depth === 1) {
      quoteTotalPrice = _.add(quoteTotalPrice, quotePrice);
      preQuoteTotalPrice = _.add(preQuoteTotalPrice, preQuotePrice);
    } else if (depth === 2 && isWin) {
      quoteTotalPrice = _.add(quoteTotalPrice, quotePrice);
      preQuoteTotalPrice = _.add(preQuoteTotalPrice, preQuotePrice);
    }
    preQuoteTotalPriceCurrency = preQuotePriceCurrency;
    return {
      id: account.id,
      quote_id: quoteId,
      index: index + 1,
      platform: superior_resource_ships.map((i: any) => i.name).join(intl.formatMessage(messages.comma_alias)),
      account: account.account,
      remark: account.remark,
      // TODO 上一轮报价
      pre_quote_price: preQuotePrice === 0 ? '' : preQuotePrice,
      pre_quote_price_currency: preQuotePriceCurrency,
      quote_price: quotePrice === 0 ? '' : quotePrice,
      is_win: isWin,
      currency,
      translated_currency: currencyName,
      program_desc: programDesc,
    };
  });
  // 非 广告投放 类目
  if (!isBlank(data) && !(project_plan_info.ad_settle_way === QuotationsType.XIAOHAO)) {
    data.push({
      isTotal: true,
      index: 'total',
      quote_price: quoteTotalPrice === 0 ? '' : quoteTotalPrice,
      pre_quote_price: preQuoteTotalPrice === 0 ? '' : preQuoteTotalPrice,
      pre_quote_price_currency: preQuoteTotalPriceCurrency,
    });
  }
  return data;
};
